import React from "react";
import { Link } from "@cloudscape-design/components";

import { SentinelInfoSection } from "./sentinel-info-section";
import { MonitorSchedules } from "src/web/components/MonitorSchedules";
import { DEFAULT_CR_LIMIT, TEAMS_RECORD_URL } from "src/web/constants";

export const SentinelOnboardingPageInfoSection = () => (
    <SentinelInfoSection header="Onboarding Page">
        <div>
            <p>
        On this page you will be able to onboard your team owned pipelines to Dependency Sentinel. You can do multiple pipelines in a single onboarding.
            </p>

            <h4>What happens after you onboard</h4>
            <p>
        Onboarding records your pipelines. It does not scan them straight away, so you
        should not expect packages, dependencies, or code reviews to appear immediately.
        The work happens on the scheduled runs below.
            </p>
            <h4>Refresh schedule</h4>
            <MonitorSchedules />

            <h4>How many code reviews you will get</h4>
            <p>
        Dependency Sentinel keeps at most a certain amount of code reviews open for your
        team at a time. The limit counts reviews that are still open, so as you merge or
        close them, the daily run raises more until your upgradable dependencies are
        exhausted. If you see no new code reviews, check whether you are already at your
        limit.
            </p>
            <p>
        You can optionally set your code review limit when you onboard your team.
        Leaving it blank keeps your team's current limit, or the default
        of {DEFAULT_CR_LIMIT}. A value you do submit
        is applied as given, so the limit can be lowered as well as raised, and a limit of 0
        stops new code reviews being raised for your team entirely.
            </p>

            <h4>Team name</h4>
            <p>
        Team Name must match your team exactly as it is recorded in{" "}
                <Link href={TEAMS_RECORD_URL} external={true}>
            Teams
                </Link>
        , and you must be a member of that team for the request to be accepted.
            </p>
        </div>
    </SentinelInfoSection>
);
